<template>
  <footer>
    <div class="social">
      <ul>
        <li>
          <a :href="configData.general.socialNetworks.facebook" target="_blank"
            ><i class="fa fa-facebook"></i
          ></a>
        </li>
        <li>
          <a :href="configData.general.socialNetworks.instagram" target="_blank"
            ><i class="fa fa-instagram"></i
          ></a>
        </li>
        <li>
          <a :href="configData.general.socialNetworks.youtube" target="_blank"
            ><i class="fa fa-youtube-play"></i
          ></a>
        </li>
        <li>
          <a :href="configData.general.socialNetworks.youtube" target="_blank"
            ><i class="fa fa-linkedin"></i
          ></a>
        </li>
      </ul>
    </div>
    <div class="row sinmargen fondo-gris">
      <div class="container">
        <div class="row enlaces-rapidos">
          <div class="col-md-4">
            <div class="logo-iff">
              <img :alt="configData.general.brandName" src="@/assets/logo-iff.png" />
            </div>
            <div class="resumen">
              {{ configData.general.brandSubject }}
            </div>
          </div>
          <div class="col-md-4">
            <h4><strong>ENLACES RÁPIDOS</strong></h4>
            <ul class="enlaces" style="text-align: left;">
              <template v-for="section in section_list">
                <li>
                  <router-link :to="'/' + section.url_es"
                    ><span>{{ section.name_sec_es }}</span></router-link
                  >
                </li>
              </template>
            </ul>
          </div>
          <div class="col-md-4">
            <ul class="accesos">
              <li v-if="configData.general.isLoggingAvailable">
                <a href="" class="acceso" data-toggle="modal" data-target="#myModal2"
                  ><span class="material-icons-outlined">vpn_key</span> Iniciar Sesión</a
                >
              </li>
              <li v-if="configData.general.isLoggingAvailable">
                <router-link :to="'/registrar'" class="acceso"
                  ><span class="material-icons-outlined">account_circle</span> Mi
                  Cuenta</router-link
                >
              </li>
              <li v-if="configData.general.isEcommercePage">
                <router-link :to="'/carrito'" class="acceso"
                  ><span class="material-icons-outlined">shopping_cart</span> Mi
                  Carrito</router-link
                >
              </li>
              <li>
                <a :href="configData.general.corporateWebPage" class="acceso"
                  ><span class="material-icons-outlined">business</span>
                  {{ configData.general.brandName }}</a
                >
              </li>
              <li class="img-libro-reclamaciones">
                <router-link :to="'/reclamo'" class="acceso link-libro-reclamaciones"></router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="row sinmargen fondo-azul">
      <div class="container copydev">
        <div class="copyright">
          Copyright © {{ getActualYear() + ' ' + configData.general.brandShortName }}. Todos los
          derechos reservados.
        </div>
        <div class="developed">
          Desarrollado por:
          <a :href="'http://' + configData.general.developerCorporateWebPage"
            ><img src="@/assets/analysofti-logo.png" :alt="configData.general.developerName"
          /></a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  props: ['section_list','configData'],
  methods: {
    getActualYear() {
      var today = new Date();
      var year = today.getFullYear();
      return year;
    },
  },
};
</script>
